export default __webpack_public_path__ + "static/media/sass-thumb-1.fffa66e6.png";